import classNames from 'classnames';
import React from 'react';
import EmbedComponent from './EmbedComponent';
import styles from './EmbedContent.module.scss';
import EmbedFooter, { embedsWithNativeFooter } from './EmbedFooter';
import EmbedPostContent from './EmbedPostContent';
import type { PreviewMode } from './matchEmbed';

interface EmbedContentProps {
  id: string;
  type: string;
  params?: string;
  readOnly: boolean;
  disableContentSelection?: boolean;
  previewMode?: PreviewMode;
}

const EmbedContent = ({
  id,
  type,
  params,
  readOnly,
  disableContentSelection,
  previewMode,
}: EmbedContentProps) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention -- Add boolean prefix next time file is edited
  const nativeFooter = type === 'post' || embedsWithNativeFooter.includes(type);

  const contentClassName = classNames(styles.content, 'embed-inner-content', {
    [styles.hasNativeFooter]: nativeFooter,
  });

  return (
    <div
      className={classNames(
        `${type}-embed`,
        'embed-content',
        styles.container,
        {
          [styles.disableContentSelection]: disableContentSelection,
          'embed-with-native-footer': nativeFooter,
        },
      )}
    >
      {type === 'post' ? (
        <div className={classNames(contentClassName, styles.post)}>
          <EmbedPostContent id={id} />
        </div>
      ) : (
        <EmbedComponent
          className={contentClassName}
          id={id}
          type={type}
          params={params}
          readOnly={readOnly}
          previewMode={previewMode}
        />
      )}
      <div
        className={classNames(styles.footer, 'embed-footer', {
          [styles.hasNativeFooter]: nativeFooter,
        })}
      >
        <EmbedFooter id={id} type={type} params={params} />
      </div>
    </div>
  );
};

export default EmbedContent;
